import type { BenefitCategory } from "@yutai/shared"
import styles from "./CategoryBadge.module.css"

const LABELS: Record<BenefitCategory, string> = {
  food: "食品・飲料",
  dining: "外食",
  travel: "旅行・宿泊",
  discount: "割引券",
  quo: "QUO・商品券",
  catalog: "カタログ",
  digital: "デジタルギフト",
  own: "自社製品",
  donation: "寄付",
  tour: "施設見学",
  other: "その他",
}

interface Props {
  category: BenefitCategory
}

export function CategoryBadge({ category }: Props) {
  return <span className={`${styles.badge} ${styles[category]}`}>{LABELS[category]}</span>
}
